import { pageSize } from "@/components/Joyspace/config/basics.config";
import context from "@/components/Joyspace/context";
import events from "@/components/Joyspace/context/events";
import JoyspaceController, {
  SyncStatusEunm
} from "@/components/Joyspace/controllers/JoyspaceController";
import { ActionFnEnum, ActionType, MenusType } from "@/components/Joyspace/types";
import { handleRootId, partialRefresh, removeDuplicate, time } from "@/components/Joyspace/util";
import { getNetCheckUrl } from "@/config/config";
import { FilterInfoState } from "@/models/joyspace";
import NetworkCheck, { useNavigator } from "@/utils/NetworkCheck";
import React, { useContext, useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Sort } from "../../List/Filters/config";
import { ICategory, IPage, ReadyState } from "../../List/types";
function saveToDB(data: any) {
  try {
    const { key, pages, categories, actionType = ActionType.Page, parentId = "" } = data;
    const Controller = JoyspaceController;
    let args: any = { start: 0, length: 30 };
    switch (key) {
      case MenusType.SHORTCUT:
        Controller.setShortcutsList(key, { shortcuts: pages }, args);
        break;
      case MenusType.RECENT:
        Controller.setList(key, { pages: pages }, args);
        break;
      case MenusType.SHAREBY:
        Controller.setList(key, { pages: pages }, args);
        break;
      case MenusType.SHARE:
        Controller.setSharesList(key, { shares: pages }, args);
        break;
      case MenusType.COLLECTION:
        Controller.setCollectionsList(key, { data: pages }, args, actionType);
        break;
      case MenusType.TRASHES:
        Controller.setTrashesList(key, { trashes: pages }, args);
        break;
    }
    if (key === MenusType.SPACE) {
      if (actionType === ActionType.Folder) {
        Controller.setFolderList("getFileList", categories, parentId);
      } else if (actionType === ActionType.Page) {
        Controller.setList("space", { pages: pages }, args, parentId);
      } else {
        Controller.setFolderList("getFileList", categories, parentId);
        Controller.setList("space", { pages: pages }, args, parentId);
      }
    }
  } catch (error) {
    console.log("saveDbError", error);
  }
}
export function useListData({
  requestPagesFunc,
  requestCategoriesuFunc,
  isFilter = true,
  isCategory = true,
  defaultCategoryId,
  pageKey = "pages",
  key,
  defaultFilterInfo,
  isEmitLoadMore,
  isGroup = false
}: {
  requestPagesFunc?: Function;
  requestCategoriesuFunc?: Function;
  isFilter?: boolean;
  isCategory?: boolean;
  defaultCategoryId?: string;
  defaultFilterInfo?: FilterInfoState;
  pageKey?: string;
  key: string;
  isEmitLoadMore?: boolean;
  isGroup?: boolean;
}) {
  const [pages, setPages] = React.useState<IPage[]>([]);
  const [total, setTotal] = React.useState<number>(0);
  const [selecteds, select] = React.useState(new Set());
  const [pageIndex, setPageIndex] = React.useState(0);
  const [list, setList] = React.useState<any[]>([]);
  const [categories, setCategories] = React.useState<ICategory[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [pageLoding, setPageLoding] = React.useState(false);
  const { currentRouterInfo, filterInfo: contextfilterInfo } = useContext(context);
  const [categoryId, setCategoryId] = React.useState<string | null>(
    defaultCategoryId || currentRouterInfo?.id || null
  );
  const [filterInfo, setFilterInfo] = useState(defaultFilterInfo || contextfilterInfo);
  const lastRequestVersionRef = useRef<any>({});
  const [isLoadMore, setLoadMore] = React.useState(true);
  useEffect(() => {
    if (defaultFilterInfo) {
      setFilterInfo(defaultFilterInfo);
      return;
    }
    setFilterInfo(contextfilterInfo);
  }, [contextfilterInfo, defaultFilterInfo]);
  useEffect(() => {
    setCategoryId(currentRouterInfo?.id || null);
  }, [currentRouterInfo]);

  // 获取数据
  const getPageList = async (
    start = 0,
    categoryId: string | null,
    filterInfo?: FilterInfoState
  ) => {
    if (!requestPagesFunc) {
      return { pages: [], total: 0 };
    }
    const params: any = {
      start,
      length: pageSize
    };
    if (isFilter && filterInfo) {
      params.order = filterInfo.order;
      params.sort = filterInfo.sort;
    }
    let res: any = await requestPagesFunc(
      params,
      isCategory ? (categoryId === "myspace" ? "$myspace" : categoryId) : undefined
    );
    if (res) {
      res.pages = (res[pageKey] || []).map((item: any) => {
        if (isFilter && filterInfo) {
          let _time;
          switch (filterInfo.sort) {
            case Sort.CreateTime:
              _time = item.created_at;
              break;
            case Sort.ModifiedTime:
              _time = item.modified_at;
              break;
            case Sort.OpenTime:
              _time = item.openTime;
              break;
            default:
              _time = item.updated_at;
              break;
          }
          item.time = time.format(_time);
        }
        item.title = item.title || "无标题";

        if (item.isNew && useNavigator.onLine && item.syncStatus === SyncStatusEunm.PROCESS) {
          item.isDisabled = true;
        }
        // item.isDisabled = true;
        return item;
      });
    } else {
      // eslint-disable-next-line no-param-reassign
      res = { pages: [], total: 0 };
    }
    return res;
  };
  const getFolderList = async (categoryId: string | null) => {
    if (!requestCategoriesuFunc) {
      return [];
    }
    const params: any = {};

    if (isFilter && filterInfo) {
      params.order = filterInfo.order;
      params.sort = filterInfo.sort;
    }
    if (isCategory && !defaultCategoryId) {
      params.authFolder = categoryId; // 无权限页面/已删除页面跳转
    }
    if (isGroup) {
      params.isGroup = isGroup;
      params.authFolder = categoryId;
    }
    let folderList = await requestCategoriesuFunc(categoryId, params);
    folderList = (folderList || []).map((item: any) => {
      if (isFilter && filterInfo) {
        let _time =
          filterInfo.sort === Sort.UpDateTime || filterInfo.sort === Sort.Title
            ? item.updated_at
            : item.created_at;
        item.time = time.format(_time);
      }
      item.title = item.name || "无标题";
      return item;
    });
    return folderList;
  };
  const isLoadMoreEmitFuc = (isLoadMore: boolean) => {
    console.log("isLoadMoreEmitFuc111", isLoadMore);
    isEmitLoadMore && events.emit("list.pagination", { isLoadMore: isLoadMore } as any);
  };
  const getListAll = useCallback(
    async (isSetLoading) => {
      select(new Set());
      setLoadMore(false);
      isLoadMoreEmitFuc(false);
      setTotal(0);
      setPages([]);
      setCategories([]);
      if (isCategory && !categoryId) {
        return;
      }
      isSetLoading && setLoading(true);
      const requestVersion = (lastRequestVersionRef.current.getListAll = Date.now());
      Promise.all([getFolderList(categoryId), getPageList(0, categoryId, filterInfo)])
        .then((res: any) => {
          if (requestVersion !== lastRequestVersionRef.current.getListAll) {
            return;
          }
          const pageRes = res[1] || { pages: [], total: 0 };
          const folderList = res[0] || [];
          let total = pageRes.total;
          console.log(pageRes, "pageRes111");
          const usePages = removeDuplicate(pageRes.pages);
          const useCategories = removeDuplicate(folderList);
          setCategories(useCategories);
          setPages(usePages);
          const currentLen = usePages.length;
          setLoadMore(currentLen < total);
          isLoadMoreEmitFuc(currentLen < total);
          setTotal(total);
        })
        .catch((err) => {
          setLoading(false);
          setLoadMore(false);
          isLoadMoreEmitFuc(false);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterInfo, categoryId, pages, categories, pageIndex]
  );
  useEffect(() => {
    console.log(pages.length, "pages.length");
    setPageIndex(pages.length);
  }, [pages]);
  useEffect(() => {
    console.log("getListAllshan111", categoryId, filterInfo);
    if (key === MenusType.SHORTCUT && categoryId) return;
    getListAll(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, filterInfo]);
  // 加载下一条数据
  const onButtom = useCallback(async () => {
    if (!isLoadMore || loading || (isCategory && !categoryId) || pageLoding) {
      return;
    }
    if (pageIndex >= total) {
      setLoadMore(false);
      isLoadMoreEmitFuc(false);
      return;
    }
    setPageLoding(true);
    const res = await getPageList(pageIndex, categoryId, filterInfo);
    if (!res) {
      setPageLoding(false);
      return;
    }
    const usePages = removeDuplicate(pages.concat(res.pages));
    console.log(usePages, "usePages");
    setPages(usePages);
    const currentLen = usePages.length;
    const _total = res.total;
    setLoadMore(currentLen < _total);
    isLoadMoreEmitFuc(currentLen < _total);
    setTotal(_total);
    setPageLoding(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pageIndex,
    total,
    categoryId,
    loading,
    pageLoding,
    isLoadMore,
    filterInfo,
    isCategory,
    pages
  ]);
  useEffect(() => {
    setList([...categories, ...pages]);
  }, [pages, categories]);
  const reload = useCallback(
    (data: { folderId?: string; key?: string; type?: ActionType } = {}) => {
      const { folderId, key: useKey, type = ActionType.ALL } = data;
      if (type === ActionType.Page && !requestPagesFunc) return;
      if (type === ActionType.Folder && !requestCategoriesuFunc) return;
      if (!useKey && key === MenusType.SHORTCUT) return;

      if (
        (!folderId || handleRootId(folderId) === handleRootId(categoryId || "")) &&
        (!useKey || useKey === key)
      ) {
        getListAll(true);
        events.emit("list.check");
      }
    },
    [getListAll, categoryId, key, requestPagesFunc, requestCategoriesuFunc]
  );
  const syncReload = useCallback(
    (data: { folderId?: string; key?: string; type?: ActionType } = {}) => {
      const { folderId, key: useKey, type = ActionType.ALL } = data;
      if (type === ActionType.Page && !requestPagesFunc) return;
      if (type === ActionType.Folder && !requestCategoriesuFunc) return;
      if (!useKey && key === MenusType.SHORTCUT) return;
      if ((!folderId || handleRootId(folderId) === categoryId) && (!useKey || useKey === key)) {
        getListAll(false);
      }
    },
    [getListAll, categoryId, key, requestPagesFunc, requestCategoriesuFunc]
  );
  const refresh = useCallback((item: any) => {
    setPages((prvList) => {
      const data = partialRefresh(item, prvList, "page_id");
      return data;
    });
  }, []);
  const handlePartialRefresh = useCallback(
    // eslint-disable-next-line complexity
    ({
      folderId,
      changeData,
      key: useKey,
      withOutSave = false
    }: {
      folderId?: string;
      changeData: any;
      key?: MenusType;
      withOutSave?: boolean;
    }) => {
      try {
        const checked =
          (!folderId ||
            handleRootId(folderId) === categoryId ||
            (folderId === "" && categoryId === "myspace")) &&
          (!useKey || key === useKey);
        if (!checked) return;
        if (key === MenusType.GROUPSPACE) {
          withOutSave = false;
        }
        let { type, pids, cids, newItem, id, actionType } = changeData;
        switch (type) {
          case ActionFnEnum.REMOVE:
          case ActionFnEnum.BATCHREMOVE: {
            if (type === ActionFnEnum.REMOVE) {
              if (!(id && actionType)) return;
              // console.log("remove111", id, pages, categories);
              if (actionType === ActionType.Folder) {
                cids = [id];
              } else {
                pids = [id];
              }
            }
            let newPages = pages;
            let newCategorys = categories;
            if (pids) {
              newPages = pages.filter((page) => {
                const pageId = page.page_id || page.id;
                return !pids.includes(pageId);
              });
            }
            if (cids) {
              newCategorys = categories.filter((category) => {
                const categoryId = category.category_id || category.id;
                return !cids.includes(categoryId);
              });
            }
            if (newPages.length !== pages.length) {
              setPages(newPages);
              setTotal((preTotal) => {
                return preTotal - (pages.length - newPages.length);
              });
              !withOutSave &&
                saveToDB({
                  key,
                  pages: newPages,
                  actionType: ActionType.Page,
                  parentId: categoryId
                });
            }
            if (newCategorys.length !== categories.length) {
              setCategories(newCategorys);
              !withOutSave &&
                saveToDB({
                  key,
                  categories: newCategorys,
                  actionType: ActionType.Folder,
                  parentId: categoryId
                });
            }
            break;
          }
          case ActionFnEnum.ADD: {
            //   console.log(newItem, "add1111");
            if (!newItem) return;
            if (typeof newItem.page_type !== "undefined" && requestPagesFunc) {
              const newPages = [newItem, ...pages];
              setPages(newPages);
              setTotal((preTotal) => {
                return preTotal + 1;
              });
              !withOutSave &&
                saveToDB({
                  key,
                  pages: newPages,
                  actionType: ActionType.Page,
                  parentId: categoryId
                });
              return;
            }
            if (typeof newItem.page_type === "undefined" && requestCategoriesuFunc) {
              if (isFilter && filterInfo) {
                let _time =
                  filterInfo.sort === Sort.UpDateTime || filterInfo.sort === Sort.Title
                    ? newItem.updated_at
                    : newItem.created_at;
                newItem.time = time.format(_time);
              }
              const newCategorys = [newItem, ...categories];
              setCategories(newCategorys);
              !withOutSave &&
                saveToDB({
                  key,
                  categories: newCategorys,
                  actionType: ActionType.Folder,
                  parentId: categoryId
                });
              return;
            }
            break;
          }
          case ActionFnEnum.UPDATE: {
            if (!(newItem && id && actionType)) {
              return;
            }
            let checkData: any[] = pages;
            let setFuc: Function = setPages;
            if (actionType === ActionType.Folder) {
              checkData = categories;
              setFuc = setCategories;
            }
            for (let i = 0; i < checkData.length; i++) {
              const data: any = checkData[i];
              const checkId = data.id || data.page_id || data.category_id;
              if (checkId === id) {
                checkData[i] = {
                  ...checkData[i],
                  ...newItem
                };
                const saveData = [...checkData];
                setFuc(saveData);
                const saveInfo: any = {
                  key,
                  parentId: categoryId,
                  actionType
                };
                if (saveInfo.actionType === ActionType.Folder) {
                  saveInfo.categories = saveData;
                } else {
                  saveInfo.pages = saveData;
                }
                !withOutSave && saveToDB(saveInfo);
                return;
              }
            }
            break;
          }
        }
      } catch (e) {
        console.log("handlePartialRefreshError", e);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pages, categories, categoryId]
  );

  const offlineHandle = useCallback(async () => {
    if (pages.length === 0) return;
    const allPages = await JoyspaceController?.setOffLineList(pages);
    setPages([...allPages]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages, setPages]);
  useEffect(() => {
    if (key === MenusType.GROUPSPACE) return;

    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl()
    });
    netServer?.on("offline-event", offlineHandle);
    return () => {
      netServer?.off("offline-event", offlineHandle);
    };
  }, [offlineHandle, key]);
  useEffect(() => {
    events.on("list.partial.refresh", handlePartialRefresh);
    return () => {
      events.off("list.partial.refresh", handlePartialRefresh);
    };
  }, [handlePartialRefresh]);
  useEffect(() => {
    events.on("list.reload", reload);
    events.on("list.refresh", refresh);
    events.on("list.syncReload", syncReload);
    return () => {
      events.off("list.reload", reload);
      events.off("list.refresh", refresh);
      events.off("list.syncReload", syncReload);
    };
  }, [refresh, reload, syncReload]);
  return {
    list,
    setList,
    loading,
    total,
    isLoadMore,
    setLoadMore,
    setTotal,
    onButtom,
    selecteds,
    select,
    setCategoryId,
    reload,
    pageIndex,
    setPageIndex,
    setFilterInfo
  };
}
